import React from 'react'
import LeaveReportees from './LeaveReportees'

export default function DirectReporteesGrid({searchTerm,employeeData,shiftStart,shiftEnd}) {
    return (
        <div className="w-full sm:grid sm:gap-3 sm:grid-cols-3">
            <LeaveReportees searchTerm={searchTerm} employeeData={employeeData} shiftStart={shiftStart} shiftEnd={shiftEnd}/>
        </div>
    )
}
